import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

interface Props {
  isMain?: boolean;
}

const GameHeader = ({ isMain = false }: Props) => {
  const navigate = useNavigate();
  return (
    <Header>
      <Content>
        <div>
          <img
            src="/assets/images/logo/zipgoai_logo_mobile_header.svg"
            style={{ height: '36px', cursor: 'pointer' }}
            onClick={() => {
              navigate('/');
            }}
          />
        </div>
        <CloseBox onClick={() => navigate(-1)}>
          <img src="/assets/images/icon/icon_game_close.svg" alt="close" />
        </CloseBox>
      </Content>
    </Header>
  );
};

export default GameHeader;

const Header = styled.div`
  display: flex;
  padding: 0 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-bottom: 1px solid #e1e2e4;
`;
const Content = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 0;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 68px;
`;
const CloseBox = styled.div`
  padding: 10px;
  cursor: pointer;
  display: flex;
`;
